import React from 'react'
import { StatCards } from '@/shared/ui'
import { useOportunidadesStats } from '../hooks/useOportunidadesStats'

export default function OportunidadesStatsCards() {
  const { stats, loading, error } = useOportunidadesStats()
  const hasStats = stats !== null
  const fmt = (n?: number | null) => (!hasStats && loading ? '...' : (n ?? 0).toLocaleString('pt-BR'))

  return (
    <div className="mb-6">
      {error && (
        <div className="mb-3 rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">
          {error}
        </div>
      )}
      <StatCards
        items={[
          {
            label: 'Ativas',
            value: fmt(stats?.totalActive),
            tone: 'primary',
          },
          {
            label: 'bullish',
            value: fmt(stats?.longActive),
            tone: 'success',
          },
          {
            label: 'bearish',
            value: fmt(stats?.shortActive),
            tone: 'warning',
          },
          {
            label: 'Monitorando',
            value: fmt(stats?.monitoringActive),
            tone: 'violet',
          },
        ]}
        className="grid-cols-4 gap-2 sm:gap-3"
      />
    </div>
  )
}
